<template>
  <TechLayoutContainer>
    <!-- 组播配置列表 -->
    <div class="list-container">
      <MulticastList
        :loading="loading"
        :dataList="multicastList"
        :total="total"
        :currentPage="currentPage"
        @edit="handleEdit"
        @delete="handleDelete"
        @status-change="handleStatusChange"
        @page-change="handlePageChange"
        @refresh="loadMulticastList"
        @add="handleAdd"
      />
    </div>

    <!-- 编辑弹窗 -->
    <MulticastForm
      v-model="showForm"
      :editData="editData"
      :isEdit="isEdit"
      @success="handleFormSuccess"
    />
  </TechLayoutContainer>
</template>

<script>
import TechLayoutContainer from '@/components/TechLayoutContainer'
import MulticastList from './components/MulticastList.vue'
import MulticastForm from './components/MulticastForm.vue'
import api from '@/api'

export default {
  name: 'MulticastConfig',
  components: {
    TechLayoutContainer,
    MulticastList,
    MulticastForm
  },
  data() {
    return {
      loading: false,
      multicastList: [],
      total: 0,
      currentPage: 1,
      showForm: false,
      editData: null,
      isEdit: false
    }
  },
  mounted() {
    this.loadMulticastList()
  },
  methods: {
    // 加载组播配置列表
    loadMulticastList() {
      this.loading = true

      api.getData(`robot-server/robot/multicast/list?index=${this.currentPage}`).then(response => {
        this.loading = false
        if (response.state === 0) {
          this.$Notice.error({
            title: this.$translate('tip'),
            desc: response.msg
          })
        } else {
          this.multicastList = response.data.rows || []
          this.total = response.data.total || 0
        }
      })
    },

    // 新增配置
    handleAdd() {
      this.isEdit = false
      this.editData = null
      this.showForm = true
    },

    // 编辑配置
    handleEdit(item) {
      this.isEdit = true
      this.editData = item
      this.showForm = true
    },

    // 删除配置
    handleDelete(item) {
      this.$Modal.confirm({
        title: this.$translate('confirmDelete'),
        content: `${this.$translate('deleteConfigurationMessage')}【${item.name}】？`,
        onOk: () => {
          api.getData(`robot-server/robot/multicast/delete/${item.id}`, {}).then(response => {
            if (response.state === 0) {
              this.$Notice.error({
                title: this.$translate('tip'),
                desc: response.message
              })
            } else {
              this.$Notice.success({
                title: this.$translate('tip'),
                desc: this.$translate('deleteSuccess')
              })
              this.loadMulticastList()
            }
          })
        }
      })
    },

    // 启用/禁用状态切换
    handleStatusChange(item, enabled) {
      api.getData(`robot-server/robot/multicast/status/${item.id}/${enabled ? 1 : 2}`, {}).then(response => {
        if (response.state === 0) {
          this.$Notice.error({
            title: this.$translate('tip'),
            desc: response.message
          })
        } else {
          this.$Notice.success({
            title: this.$translate('tip'),
            desc: this.$translate(enabled ? 'configurationEnableSuccess' : 'configurationDisableSuccess')
          })
          // 更新本地数据
          const index = this.multicastList.findIndex(config => config.id === item.id)
          if (index !== -1) {
            this.multicastList[index].enabled = enabled ? 1 : 2
          }
        }
      })
    },

    // 分页变化
    handlePageChange(page) {
      this.currentPage = page
      this.loadMulticastList()
    },

    // 表单操作成功
    handleFormSuccess() {
      this.showForm = false
      this.loadMulticastList()
    }
  }
}
</script>

<style lang="less" scoped>
.list-container {
  flex: 1;
  overflow: hidden;
  padding: 20px;
  position: relative;
  z-index: 15;
}
</style>
